import { useState, useLayoutEffect } from "react";
const useScreenWidth = () => {
  const mobileBreakpoint = 480;
  const [screenWidth, setScreenWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : mobileBreakpoint
  );
  const [screenHeight, setScreenHeight] = useState(
    typeof window !== "undefined" ? window.innerHeight : mobileBreakpoint
  );

  useLayoutEffect(() => {
    const handleWindowResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return { screenWidth, screenHeight, mobileBreakpoint };
};

export default useScreenWidth;
